import { Container } from '@mui/material';
import React, { Fragment, PropsWithChildren, useEffect, useState } from 'react';
import { LoginButton } from '@components';
import { useQueryParams } from '@app/hooks/useQueryParams';
import { AcceptInviteViewCreator } from '@viewCreators';
import View, { AcceptInviteView } from '@views/AcceptInviteView';

export const AcceptInvite: React.FC<PropsWithChildren> = () => {
  const viewCreator = new AcceptInviteViewCreator();
  const query = useQueryParams();
  const [view, setView] = useState<AcceptInviteView>({ ...View.Empty });

  useEffect(() => {
    setView(
      viewCreator.createViewWithArg({
        inviteCode: query.get('code'),
      })
    );
  }, []);

  const loginClickHandler = () => {};
  return (
    <Fragment>
      <Container maxWidth={'md'}>
        <LoginButton
          loginButtonHelp={view.loginButtonHelp}
          onLoginClicked={loginClickHandler}
          disabled={!view.loginEnabled}
          authenticationRedirectUrl={view?.authRedirectUrl}
        ></LoginButton>
      </Container>
    </Fragment>
  );
};
